var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 6.37812L11.9688 6.7803L12.3438 6.41163C13.375 5.30564 14.8438 4.80292 16.25 5.07104C18.4062 5.4397 20 7.45059 20 9.79663V9.96421C20 11.3718 19.4375 12.7124 18.5 13.6508L12.8438 19.3149C12.625 19.5495 12.3125 19.65 12 19.65C11.6562 19.65 11.3438 19.5495 11.125 19.3149L5.46875 13.6508C4.53125 12.7124 4 11.3718 4 9.96421V9.79663C4 7.45059 5.5625 5.4397 7.71875 5.07104C9.125 4.80292 10.5938 5.30564 11.625 6.37812C11.625 6.41163 11.5938 6.37812 11.625 6.37812ZM11.9688 9.05931L10.5625 7.51762C9.875 6.81381 8.90625 6.47866 7.96875 6.64624C6.53125 6.91436 5.5 8.22144 5.5 9.79663V9.96421C5.5 10.9361 5.84375 11.841 6.5 12.4778L12 17.9743L17.4688 12.4778C18.125 11.841 18.5 10.9361 18.5 9.96421V9.79663C18.5 8.22144 17.4375 6.91436 16 6.64624C15.0625 6.47866 14.0938 6.81381 13.4062 7.51762L11.9688 9.05931Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconPurple);
export default __webpack_public_path__ + "static/media/heartIconPurple.fbad0343fc5e8cf8c8606217cd2d64cd.svg";
export { ForwardRef as ReactComponent };